import React from 'react';

import { Icons } from '@components/common';
import UsersTable from '@components/UsersTable';

import { searchPlaceholder, searchTooltipText } from './constants';

import styles from './UsersMainTableHOC.module.scss';

const UsersMainTableHOC = () => (
	<div className={styles.usersContainer}>
		<div className={styles.pageTitle}>
			<div className={styles.icon}>{Icons.users({ isActive: true })}</div>
			<div className={styles.title}>Manage Users</div>
		</div>
		<div className={styles.usersTableContainer}>
			<UsersTable
				isCreatable
				isManageUsersTable
				isRemoveActions
				searchPlaceholder={searchPlaceholder}
				searchTooltipText={searchTooltipText}
			/>
		</div>
	</div>
);

export default UsersMainTableHOC;
